export default "__VITE_ASSET__e4864e4a__"